export const FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST = "FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST";
export const FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS = "FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS";
export const FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE = "FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE";
export const FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_RESET = "FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_RESET";
export const fetchWhatsappNdrVerificationChargesRequest = (payload) => ({
    type: FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST,
    payload,
});
export const fetchWhatsappNdrVerificationChargesSuccess = (payload) => ({
    type: FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS,
    payload,
});
export const fetchWhatsappNdrVerificationChargesFailure = (payload) => ({
    type: FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE,
    payload,
});
export const fetchWhatsappNdrVerificationChargesReset = () => ({
    type: FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_RESET,
});
